import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { fetchIntranetAuth } from "../services/api/public/fetchIntranetAuth";
import AuthLoading from "../components/AuthLoading/AuthLoading";

export default function ProtectedRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(true);

  const { slugInUrl, tokenInUrl } = useMemo(() => {
    const path = location.pathname.replace(/^\/+|\/+$/g, "");
    const [seg1, seg2] = path.split("/");

    const isAlphanumericToken =
      typeof seg2 === "string" && /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d_-]+$/.test(seg2);

    if (seg1 && seg2 && isAlphanumericToken) {
      return { slugInUrl: seg1, tokenInUrl: seg2 };
    }
    return { slugInUrl: null, tokenInUrl: null };
  }, [location.pathname]);

  useEffect(() => {
    const boot = async () => {
      try {

        if (slugInUrl && tokenInUrl) {
          // const ipRes = await fetch("https://api.ipify.org?format=json");
          // const { ip } = await ipRes.json();

          const data = await fetchIntranetAuth({
            slug: slugInUrl,
            api_key: tokenInUrl,
            // ip_address: ip,
          });

          if (data?.token) {
            localStorage.setItem("token_url", data.token); 
            navigate("/news-stand", { replace: true });
            return;
          }

          navigate("/access-denied", { replace: true });
          return;
        }

        const existingToken = localStorage.getItem("token_url");
        console.log("existingToken", existingToken);
        if (!existingToken) {
          navigate("/access-denied", { replace: true });
          return;
        }
      } catch (e) {
        console.error("Erro no ProtectedRoute:", e);
        navigate("/access-denied", { replace: true });
      } finally {
        setProcessing(false);
      }
    };

    boot();
  }, [slugInUrl, tokenInUrl, navigate]);

  if (processing) {
    return <AuthLoading message="Validando seu acesso..." />;
  }

  return <Outlet />;
}
